<app-loader></app-loader>
<div class="smart-telemetric-banner" *ngIf="!isSmartTelemetrics && !isFred">
	{{"g.smart_telemetrics_banner" | translate:{ "siteName": siteName } }}<a href="https://www.smartchargetech.com/smart-telemetric-announcement/" target="_blank">[Learn more]</a>
</div>
<div>
	<div class="page-container" [class.with-smart-telemetric-banner]="!isSmartTelemetrics && !isFred">
		<app-notification-message></app-notification-message>
		<header>
			<img src="/sctportal/{{loginLogo}}" [class]="imageClass" alt="smartTelemetrics">
			<div></div>
		</header>
		<div class="form-container" [class.center]="centralizeTemplate">
			<div class="login-text" *ngIf="!centralizeTemplate">
				<h1>{{ pagesTitles[page] | translate}}</h1>
				<h1 *ngIf="page == 'login'">{{"login_register.your_account" | translate}}</h1>
				<p *ngIf="pagesSubTitles[page]">{{ pagesSubTitles[page] }}</p>
			</div>
			<router-outlet></router-outlet>
		</div>
		<footer>
			<p>
				{{"© " + copyrightYear + " " + siteName}}. {{"g.all_rights_reserved" | translate}}
				<span class="mx-1">|</span>
				<a routerLink="/terms-and-conditions">{{'terms.title' | translate}}</a>
				<span class="mx-1">|</span>
				<a routerLink="/privacy-policy">{{'privacy.privacy_policy' | translate}}</a>
			</p>
			<div class="mobile-apps">
				<a href="{{appStoreAppLink}}" target="_blank">
					<img src="/sctportal/images/smartTelemetrics/app_store.svg" alt="smartTelemetrics">
				</a>
				<a href="{{googlePlayAppLink}}" target="_blank">
					<img src="/sctportal/images/smartTelemetrics/google_play.svg" alt="smartTelemetrics">
				</a>
			</div>
		</footer>
		<div class="cloud-container">
			<div class="clouds"></div>
		</div>
	</div>
</div>
